import { Component } from "react";
import Box from '@mui/material/Box';
import ProfileHeader from "../../../components/ProfileHeader";
import { useParams, useNavigate, NavigateFunction } from "react-router-dom";
import { getPopulatedContext } from "./DocumentDetailContext";
import { HOST } from "../../../api/config/Constants";
import { Document, Page, pdfjs } from 'react-pdf';
import Fab from '@mui/material/Fab';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import FileDownloadIcon from '@mui/icons-material/FileDownloadOutlined';
import { getDocumentName } from "../unitDetail";
import CircularProgress from '@mui/material/CircularProgress';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { getSessionStorage } from "../../../utils/StorageUtil";
import { TOKEN_SO_KEY } from "../../../utils/accountUtils";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

type Props = {
  params?: {
    domain: string,
    id: string,
  },
  navigate?: NavigateFunction
}

type State = {
  unitDocument: any,
  documentTypes: any[]
  documentType: any,
  pdfFile: any,
  loaded: boolean
}

class DocumentDetail extends Component<Props, State> {
  constructor(props: any) {
    super(props)
    this.state = {
      unitDocument: null,
      documentTypes: [],
      documentType: null,
      pdfFile: null,
      loaded: false
    }
    this.setData()
  }

  setData () {
    getPopulatedContext(this.props.params!.domain, this.props.params!.id)
    .then(populatedContext => {
      this.setState({
        unitDocument: populatedContext.unitDocument,
        documentTypes: populatedContext.documentTypes,
        documentType: populatedContext.documentType,
        pdfFile: populatedContext.pdfFile?.data,
        loaded: true
    })
    })
  }

  handleGoBack = () => {
    if (!this.props.navigate) return
    this.props.navigate(`/web/unit-detail/${this.props.params!.domain}`, { replace: true })
  }

  handleUpload = () => {
    if (!this.props.navigate) return
    this.props.navigate(`upload`, { replace: true })
  }

  handleDownload = () => {
    const name = getDocumentName(this.state.unitDocument, this.state.documentTypes, this.props.params!.domain);
    fetch(`${HOST}/${this.state.unitDocument.mediaURL}`)
    .then(response => response.blob())
    .then(blob => {
      const file = new File([blob], name, { type: this.state.unitDocument.fileContentType });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(file);
      link.download = name;
      link.click();
    });
  }

  componentWillUnmount() {
    document.body.classList.remove("grey-background");
  }

  render() {
    if (!document.body.classList.contains("grey-background")) {
      document.body.classList.add("grey-background");
    }
    return (
      <Box>
        <ProfileHeader></ProfileHeader>
        <Box sx={{margin: '0 4%'}}>
          <Box className="document-detail-title">{this.state.documentType?.typedoc?.name}</Box>
          { !this.state.loaded && <CircularProgress />}
          { this.state.loaded && this.state.unitDocument?.fileContentType === "application/pdf" && this.state.pdfFile && (
            <Document file={{ data: this.state.pdfFile }} className="pdf-no-title" >
              <Page pageNumber={1}/>
            </Document>
          )}
          { this.state.loaded && this.state.unitDocument?.fileContentType !== "application/pdf" && <img src={`${HOST}/${this.state.unitDocument?.mediaURL}`} alt={this.state.unitDocument?.documentType?.name} />}
        </Box>
        <Box className="bottom-nav">
          {/* {getSessionStorage(TOKEN_SO_KEY) && (  <IconButton className="bottom-nav-text-icon" disabled={!getSessionStorage(TOKEN_SO_KEY)} onClick={this.handleUpload}>
            <UploadFileIcon />
          </IconButton>)}
         */}
          <IconButton className="bottom-nav-text-icon" //disabled={!this.state.pdfFile} 
          onClick={this.handleDownload}>
            <FileDownloadIcon />
          </IconButton>
          <Box sx={{flexGrow: "1"}}/>
          <Fab className="bottom-nav-fab" onClick={this.handleGoBack}>
            <ArrowBackIcon />
          </Fab>
        </Box>
      </Box>
    )
  }
 
}

function withParams(Component: any) {
  return (props: Props) => <Component {...props} params={useParams()} navigate={useNavigate()} />;
}

export default withParams(DocumentDetail);